"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Eip155Provider = void 0;
const protocol_1 = require("../../protocol");
const utils_1 = require("../../utils");
const media_1 = require("../../utils/media");
const InjectUtils_1 = require("../InjectUtils");
class Eip155Provider {
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                (0, utils_1.logDebug)("Eip155Provider send request:", (0, utils_1.safeJsonStringify)(request));
                yield this.restoreConnect(); //To initialize data in Discover
                let ethParams = null;
                switch (request.method) {
                    case "personal_sign":
                        if (request.params && "message" in request.params) {
                            ethParams = {
                                method: request.method,
                                params: [
                                    request.params.message,
                                    request.address,
                                ],
                            };
                        }
                        break;
                    case "eth_sendTransaction":
                    case "wallet_addEthereumChain":
                    case "wallet_switchEthereumChain":
                        {
                            if (request.params) {
                                ethParams = {
                                    method: request.method,
                                    params: [request.params],
                                };
                            }
                        }
                        break;
                    case "eth_signTypedData_v4":
                        {
                            if (request.params && "typedDataJson" in request.params && ((_a = request.params) === null || _a === void 0 ? void 0 : _a.typedDataJson) && typeof request.params.typedDataJson === "string") {
                                ethParams = {
                                    method: request.method,
                                    params: [
                                        request.address,
                                        request.params.typedDataJson,
                                    ],
                                };
                            }
                        }
                        break;
                    case "wallet_watchAsset":
                        {
                            if (request.params) {
                                ethParams = {
                                    method: request.method,
                                    params: request.params,
                                };
                            }
                        }
                        break;
                    default:
                        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
                if (ethParams) {
                    // 特殊处理 "wallet_switchEthereumChain"
                    if ((request.method === "wallet_switchEthereumChain" || request.method === "wallet_addEthereumChain")
                        && request.params
                        && "chainId" in request.params) {
                        (0, utils_1.logDebug)("Eip155Provider send request switch requestParams:", (0, utils_1.safeJsonStringify)(ethParams));
                        const switchChainId = parseInt(request.params.chainId, 16).toString();
                        yield window.okxwallet.request(ethParams);
                        const resultSwitch = `eip155:${switchChainId}:${request.address}`;
                        (0, utils_1.logDebug)("Eip155Provider send request switch result:", resultSwitch);
                        return {
                            result: resultSwitch,
                            method: request.method,
                        };
                    }
                    else {
                        const chain = (0, utils_1.getChainId)(request.chainId);
                        const chainHex = `0x${Number(chain).toString(16)}`;
                        (0, utils_1.logDebug)("Eip155Provider current chainId:", chain, chainHex);
                        if (chainHex) {
                            yield window.okxwallet.request({
                                method: "wallet_switchEthereumChain",
                                params: [{ chainId: chainHex }],
                            });
                            (0, utils_1.logDebug)("Eip155Provider send request requestParams:", chainHex, (0, utils_1.safeJsonStringify)(ethParams));
                            const resultMe = yield window.okxwallet.request(ethParams);
                            (0, utils_1.logDebug)("Eip155Provider send request result:", (0, utils_1.safeJsonStringify)(resultMe));
                            return {
                                result: resultMe,
                                method: request.method,
                            };
                        }
                    }
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
            }
            catch (error) {
                (0, utils_1.logDebug)("Eip155Provider encountered an error:", error);
                throw error;
            }
        });
    }
    connectReady() {
        return true;
    }
    restoreConnect() {
        if ((0, media_1.isDevice)("mobile")) {
            return window.okxwallet.request({ method: 'eth_requestAccounts' });
        }
        return Promise.resolve();
    }
    parseConnectResponse(needPop, accountChange, signalChain, connectWalletNameSpace, connectRequestWalletResponse, dappInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let connectChain = [];
                connectWalletNameSpace.forEach(item => {
                    if (item.namespace === protocol_1.NameSpaceKeyEip155) {
                        connectChain.push(...item.chains);
                    }
                });
                let addresses = [];
                let extra = {};
                connectChain.forEach((chainStr) => {
                    let currentChain = (0, utils_1.getChainId)(chainStr);
                    let selectedAddress = connectRequestWalletResponse.address.find((addressItem) => {
                        return (addressItem.chainId === currentChain && addressItem.coinType === 60)
                            || (addressItem.namespaceChainId === chainStr);
                    });
                    if (selectedAddress) {
                        addresses.push(chainStr + ":" + selectedAddress.address);
                        extra[chainStr] = {
                            publicKey: selectedAddress.publicKey
                        };
                    }
                });
                if (addresses && addresses.length > 0) {
                    let nameSpaceResponse = {
                        namespace: protocol_1.NameSpaceKeyEip155,
                        addresses: addresses,
                        methods: [...InjectUtils_1.Eip55Methods],
                        extra: extra
                    };
                    return nameSpaceResponse;
                }
                return undefined;
            }
            catch (error) {
                throw error;
            }
        });
    }
    connect(nameSpace, dappInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            return window.okxwallet.request({ method: 'eth_requestAccounts' });
        });
    }
}
exports.Eip155Provider = Eip155Provider;
